import { Pipe, PipeTransform, inject } from '@angular/core';
import { DocService } from '../doc.service';

@Pipe({
  name: 'productName',
  pure: false,
  standalone: true
})
export class ProductNamePipe implements PipeTransform {
  private docService = inject(DocService);

  productId: string;
  productName: string;

  transform(productId: string): string {
    if (!productId) {
      return '';
    }

    if (this.productId !== productId) {
      this.productId = productId;
      this.docService.getProductName(productId).then(productName => {
        this.productName = productName;
      });
    }

    return this.productName;
  }

}
